
import { Link, NavLink } from "react-router-dom";



const InventoryUpdate = () => {

  return (


    <>
      <Link to="/Property/Bulkupdateform" className="text-dark mb-4 d-block">
        &larr; Back to Rates, Inventory and Availability
      </Link>

      <div className="mt-3">
        <NavLink to="/Property/InventoryUpdateForm" className="btn btn-black btn-square me-3 mb-2">
          Bulk Update Inventory
        </NavLink>

        <NavLink to="/Property/RateUpdateForm" className="btn btn-black btn-square mb-2">
          Bulk Update Rates
        </NavLink>
      </div>
    </>

  )
}

export default InventoryUpdate;
